<template>
  <div class="header-navigator">
    <div v-for="(route, index) in routes" :key="route.title">
      <div class="header-navigator-title" :class="{ 'current-route': isLastIndex(index) }" @click.self="goToRouteAtIndex(index)">
        {{ route.title }}<div class="route-divider" v-if="isNotLastIndex(index)">></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      routes: Array,
    },
    methods: {
      isLastIndex (index) {
        return index === (this.routes.length - 1)
      },
      isNotLastIndex (index) {
        return index != (this.routes.length - 1)
      },
      goToRouteAtIndex(index) {
        this.$router.push(this.routes[index].route)
      },
    },
 }
</script>